<template lang="pug">
.max-container.v2
  .abtn-group
    a.abtn.active(href="javascript:void(0)") {{$t('ui.deposit')}}
    a.abtn(href="javascript:void(0)" @click="toWithdraw") {{$t('ui.withdrawal')}}
  balanceInfo
  .t-content
    .nwrap.epw-nwrap
      label.col-form-label {{$t('ui.payment_option')}}:
      .ntabs
        a.epw-ntabs(href="javascript:void(0)" :class="{ 'active' : tabTarget == 'PE' }" v-if="bankModeList.includes('PE')" role='presentation' @click="changeTab('PE')")
          img(src='/images/depo/method/pe.png')
          span (Bank)
        a.epw-ntabs(href="javascript:void(0)" :class="{ 'active' : tabTarget == 'GSPAY' }" v-if="bankModeList.includes('GSPAY')" role='presentation' @click="changeTab('GSPAY')")
          img(src='/images/depo/method/gspay.png')
          span (Bank, E-wallet)
        a.epw-ntabs(href="javascript:void(0)" :class="{ 'active' : tabTarget == 'GSPAYSOLUTION' }" v-if="bankModeList.includes('GSPAYSOLUTION')" role='presentation' @click="changeTab('GSPAYSOLUTION')")
          img(src='/images/depo/method/gspay.png')
          span (Bank)
        a.epw-ntabs(href="javascript:void(0)" :class="{ 'active' : tabTarget == 'GSPAYSLTEWALLET' }" v-if="bankModeList.includes('GSPAYSLTEWALLET')" role='presentation' @click="changeTab('GSPAYSLTEWALLET')")
          img(src='/images/depo/method/gspay.png')
          span (E-wallet)
        a.epw-ntabs(href="javascript:void(0)" :class="{ 'active' : tabTarget == 'UPAY' }" v-if="bankModeList.includes('UPAY')" role='presentation' @click="changeTab('UPAY')")
          img(src='/images/depo/method/upay.png')
          span (Bank, E-wallet)
        a.epw-ntabs(href="javascript:void(0)" :class="{ 'active' : tabTarget == 'PEPINTOPUP' }" v-if="bankModeList.includes('PEPINTOPUP')" role='presentation' @click="changeTab('PEPINTOPUP')")
          img(src='/images/depo/method/pe.png')
          span (Telco)
        a.epw-ntabs(href="javascript:void(0)" :class="{ 'active' : tabTarget == 'MYTELCO' }" v-if="bankModeList.includes('MYTELCO')" role='presentation' @click="changeTab('MYTELCO')")
          img(src='/images/depo/method/mytelco.png')
          span (Telco)
        a.epw-ntabs(href="javascript:void(0)" :class="{ 'active' : tabTarget == 'WINPAY' }" v-if="bankModeList.includes('WINPAY')" role='presentation' @click="changeTab('WINPAY')")
          img(src='/images/depo/method/wp.png')
          span (Telco)
        a.epw-ntabs(href="javascript:void(0)" :class="{ 'active' : tabTarget == 'SULIFU' }" v-if="bankModeList.includes('SULIFU')" role='presentation' @click="changeTab('SULIFU')")
          img(src='/images/depo/method/usdt.png')
          span (Crypto)
        a.epw-ntabs(href="javascript:void(0)" :class="{ 'active' : tabTarget == 'MANUAL' }" v-if="bankModeList.includes('MANUAL')" role='presentation' @click="changeTab('MANUAL')")
          img(src='/images/depo/method/ob.png')
          span Manual Deposit
      
      gsPay(v-if="tabTarget==='GSPAY'" :minSettingDeposit="minDeposit" :promotionList="promoList")
      winpay(v-if="tabTarget==='WINPAY'" :minSettingDeposit="minDeposit" :promotionList="promoList")
      myTelco(v-if="tabTarget==='MYTELCO'" :minSettingDeposit="minDeposit" :promotionList="promoList")
      pe(v-if="tabTarget==='PE'" :minSettingDeposit="minDeposit" :promotionList="promoList")
      peTelco(v-if="tabTarget==='PEPINTOPUP'" :minSettingDeposit="minDeposit" :promotionList="promoList")
      manualDeposit(v-if="tabTarget==='MANUAL'" :minSettingDeposit="minDeposit" :promotionList="promoList" :operatorBankList="operatorBankList")
      sulifu(v-if="tabTarget==='SULIFU'" :minSettingDeposit="minDeposit" :promotionList="promoList" :operatorBankList="operatorBankList")
      gspaySol(v-if="tabTarget==='GSPAYSOLUTION'" :minSettingDeposit="minDeposit" :promotionList="promoList")
      gspayEwallet(v-if="tabTarget==='GSPAYSLTEWALLET'" :minSettingDeposit="minDeposit" :promotionList="promoList")
      upay(v-if="tabTarget==='UPAY'" :minSettingDeposit="minDeposit" :promotionList="promoList")
</template>
<script>
import config from "@/config"
import errorTags from "@/errorTags";
import manualDeposit from "@/components2/_manualDeposit.vue"
// import paymentGateway from "@/components2/_paymentGateway.vue"
import gsPay from "@/components2/_gsPay.vue"
import gspaySol from "@/components2/payment/_gspaySolution.vue"
import gspayEwallet from "@/components2/payment/_gspayEwallet.vue"
// import tng from "@/components2/_touchNgo.vue"
// import duitnow from "@/components2/_duitNow.vue"
import myTelco from "@/components2/payment/_myTelco.vue"
import pe from "@/components2/payment/_peBankTransfer.vue"
import peTelco from "@/components2/payment/_peTelco.vue"
import winpay from "@/components2/_winpay.vue"
import sulifu from "@/components2/payment/_sulifu.vue"
import upay from "@/components2/payment/_upay.vue"
import balanceInfo from '@/components2/_balanceInfo.vue'

export default {
  components:{
    manualDeposit,
    // paymentGateway,
    gsPay,
    // tng,
    // duitnow,
    pe,
    peTelco,
    winpay,
    myTelco,
    sulifu,
    gspaySol,
    gspayEwallet,
    upay,
    balanceInfo
  },
  // props:{
  //   bankingModeList:{
  //     type: Array,
  //     default: []
  //   },
  //   minSettingDeposit:{
  //     type: Number,
  //     default: 0.00
  //   },
  //   ibankActive : {
  //     type: Array,
  //     default: []
  //   },
  //   operatorBankList :{
  //     type: Array,
  //     default: []
  //   },
  //   promotionList: {
  //     type: Array,
  //     default: []
  //   }
  // },
  data(){
    return{
      conditionChecked: false,
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      bankModeList: [],
      // ibankActiveList: [],
      minDeposit: 0,
      minWithdrawal: 0,
      promoList: [],
      operatorBankList: [],
      showPromo: false,
      promoSelected: {
        package_id : '0'
      },
      tabTarget: 'GSPAY',
      showTutorial: false,
      showTnc: false
    }
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
  },
  watch:{
    sessionToken(newState, oldState){
      var vm = this
      if(newState === '' || newState === undefined){
        vm.$router.push("/").catch(err => {});
      }
    }
  },
  mounted(){
    let vm = this
    if (this.$store.getters.isLoggedIn) {
      vm.getBankList()
      vm.getBankingMode()
      // $("#modal-deposit").on("hidden.bs.modal", function() {
      //   vm.showPromo = false;
      //   vm.showTutorial = false;
      //   vm.showTnc = false;
      //   vm.promoSelected = {
      //     package_id : "0",
      //     promotion_id: ""
      //   }
      //   vm.bankModeList = []
      //   // vm.ibankActiveList = []
      // });
    }
    window.scroll(0,0)
  },
  methods:{
    toWithdraw(){
      this.$router.push("/withdrawal").catch(error =>{})
    },
    changeTab(target){
      if(this.tabTarget === target) return
      this.tabTarget = target
    },
    openTnc(){
      this.showTnc = true;
    },
    closeTnc(){
      this.showTnc = false;
    },
    openTutorial(){
      this.showTutorial = true;
    },
    closeTutorial(){
      this.showTutorial = false;
    },
    resetPromo(){
      this.promoSelected = {
        package_id : '0',
        promotion_id: ""
      }
    },
    selectPromo(selection, pic){
      this.showPromo = false
      if(selection === 0){
        this.promoSelected = {
          package_id : "0",
          promotion_id: ""
        }
      }else{
        this.promoSelected = selection
        this.promoSelected.pic = pic
      }
    },
    clearPromo(){
      this.promoSelected = {
        package_id : "0",
        promotion_id: ""
      }
    },
    showPromoList(e){
      this.showPromo = true;
      this.tabTarget = e.target;
    },
    getBankList() {
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/bankLookUp", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              this.bankList = response.data;
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
    getBankingMode() {
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getBankingMode", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              this.bankModeList = []
              // this.ibankActiveList = []
              let bankMode = response.data.bank_mode
              bankMode.filter(x => x.status == true).forEach(y => {
                if(y.banking_mode !== "IBANK" && y.banking_mode !== "PEEWALLET"){
                  this.bankModeList.push(y.banking_mode)
                }
              })
              const options = ['PE', 'GSPAY','GSPAYSOLUTION', 'GSPAYSLTEWALLET', 'UPAY', 'MYTELCO', 'WINPAY', 'SULIFU'];
              this.tabTarget = options.find(option => this.bankModeList.includes(option)) || 'MANUAL';
              // if(this.bankModeList.includes('GSPAYSOLUTION')){
              //   this.tabTarget = 'GSPAYSOLUTION'
              // }else{
              //   if(this.bankModeList.includes('GSPAYSLTEWALLET')){
              //     this.tabTarget = 'GSPAYSLTEWALLET'
              //   }else{
              //     if(this.bankModeList.includes('UPAY')){
              //       this.tabTarget = 'UPAY'
              //     }else{
              //       if(this.bankModeList.includes('PE')){
              //         this.tabTarget = 'PE'
              //       }else{
              //         if(this.bankModeList.includes('WINPAY')){
              //           this.tabTarget = "WINPAY"
              //         }else{
              //           if(this.bankModeList.includes('SULIFU')){
              //             this.tabTarget = "SULIFU"
              //           }else{
              //             this.tabTarget = "MANUAL"
              //           }
              //         }
              //       } 
              //     }
                                     
              //   }                 
              //   // }
              // }
              this.minDeposit = (response.data.min_setting.filter(item => item.setting_key === "min_deposit"))[0].setting_value
              this.minWithdrawal = response.data.min_setting[0].min_withdrawal

              this.operatorBankList = response.data.operator_deposit_bank_list

              // let ibank = response.data.ibank_active_bank
              // ibank.filter(x => x.status == true).forEach(y => {
              //   this.ibankActiveList.push(y.bank_id)
              // })

              this.promoList = response.data.promotion_list
              // this.promoList.sort((a, b) => (a.promotion_id > b.promotion_id) ? 1 : (a.promotion_id === b.promotion_id) ? ((a.package_amount > b.package_amount) ? 1 : -1) : -1 )
              this.operatorBankList = response.data.operator_deposit_bank_list
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
  }
}
</script>